import { DeepPartial, DeepReadonly } from 'ts-essentials';
import {
    BehaviorType,
    AnimType,
    EMPH_ID_MAP,
    ENTR_ID_MAP,
    EXIT_ID_MAP,
    PATH_ID_MAP,
    MEDIA_ID_MAP,
    ICTTLAnimateRotationBehavior,
    ICTTLAnimateScaleBehavior,
    ICTTLCommonTimeNodeData, IEGTimeNodeChoice, PresetId, STTLTimeNodeFillType, STTLTimeNodePresetClassType,
    STTLTimeNodeType,
    PresetSubtype,
} from '@tencent/slide-sdk-model';
import { IAnimModel } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import {
    PATH_ANIM_TYPES,
    presetClassTypes,
} from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import _set from 'lodash/set';

export class AnimationPropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    // eslint-disable-next-line complexity
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTTLCommonTimeNodeData>>,
        uiData: IAnimModel,
    ): void {
        // node type
        if (sdkData?.nodeType !== undefined) {
            uiData.props.nodeType = STTLTimeNodeType[sdkData?.nodeType];
            if (sdkData?.nodeType !== STTLTimeNodeType.PBDEFAULT) {
                // if ((nodeType === nodeTypes.CLICK_EFFECT && uiData.props.nodeType !== nodeTypes.CLICK_EFFECT)
                //     || (nodeType !== nodeTypes.CLICK_EFFECT && uiData.props.nodeType === nodeTypes.CLICK_EFFECT)) {
                //     if (uiData.parent?.timingModel) {
                //         uiData.parent.timingModel.resetAnimOrder();
                //     }
                // }
            }
        }

        // path
        if (sdkData?.presetClass === STTLTimeNodePresetClassType.path) {
            const path = sdkData.childTnLst?.egTimeNodeChoice?.[0]?.animMotion?.path;
            _set(uiData, 'props.path', path);
        }

        // path for 「curve up」 and 「curve down」
        if (sdkData?.presetId === PresetId.Curve
            && (
                sdkData?.presetClass === STTLTimeNodePresetClassType.entr
                || sdkData?.presetClass === STTLTimeNodePresetClassType.exit
            )) {
            const childTnChoise = sdkData.childTnLst?.egTimeNodeChoice || [];
            const child = childTnChoise?.find(c => c?.animMotion);
            if (child) {
                const path = child?.animMotion?.path;
                _set(uiData, 'props.path', path);
            }
        }
        // presetClass
        if (sdkData?.presetClass !== undefined) {
            uiData.props.presetClass = STTLTimeNodePresetClassType[sdkData?.presetClass];
        }

        // fill
        if (sdkData?.fill !== undefined) {
            uiData.props.fillType = STTLTimeNodeFillType[sdkData.fill];
        }
        // delay
        if (sdkData.stCondLst) {
            const lst = sdkData.stCondLst.cond;
            if (lst && lst.length > 0) {
                const [dict] = lst;
                if (dict?.delay !== undefined) {
                    uiData.props.delay = parseInt(dict.delay, 10);
                }
            }
        }
        // sub type
        if (sdkData?.presetSubtype !== undefined) {
            uiData.props.subType = sdkData.presetSubtype;
        }
        // childData
        const childTnLst = sdkData?.childTnLst?.egTimeNodeChoice;
        if (childTnLst && childTnLst.length > 0) {
            let maxDur = 1; // 动画持续时间最小为1ms
            // eslint-disable-next-line complexity
            childTnLst.forEach((childTNChoice: IEGTimeNodeChoice) => {
                const qualifiedAnimTypeArr = [
                    BehaviorType.animEffect,
                    BehaviorType.animScale,
                    BehaviorType.animRot,
                    BehaviorType.anim,
                    BehaviorType.animMotion,
                    BehaviorType.cmd,
                    BehaviorType.animClr,
                ];
                // eslint-disable-next-line complexity
                Object.keys(childTNChoice).forEach((key) => {
                    if (childTNChoice[key]) {
                        const tnBase = childTNChoice[key];
                        if (qualifiedAnimTypeArr.includes(key as BehaviorType)) {
                            let dur = tnBase?.cBhvr?.cTn?.dur || 0;
                            const delay = tnBase?.cBhvr?.cTn?.stCondLst?.cond[0]?.delay || 0;
                            if (dur === 'indefinite') {
                                dur = 500;
                            }
                            dur = tnBase?.cBhvr?.cTn?.autoRev ? dur * 2 : dur;
                            const totalDur = Number(dur) + Number(delay);
                            if (maxDur < totalDur) {
                                maxDur = totalDur;
                            }
                        }
                    }
                });

                // anim scale
                if (childTNChoice.animScale) {
                    const value = childTNChoice.animScale as ICTTLAnimateScaleBehavior;
                    uiData.props.by = {};
                    if (value.by?.x !== undefined) {
                        _set(uiData.props, 'by.x', value.by.x / 100000);
                    }
                    if (value.by?.y !== undefined) {
                        _set(uiData.props, 'by.y', value.by.y / 100000);
                    }
                    const uProps = uiData.props;
                    if ((uProps.by.x !== 1 && uProps.by.y !== 1) || (uProps.by.x === 1 && uProps.by.y === 1)) {
                        uiData.props.subType = PresetSubtype.Total;
                    } else if (uiData.props.by.x === 1 && uiData.props.by.y !== 1) {
                        uiData.props.subType = PresetSubtype.TopBottom;
                    } else {
                        uiData.props.subType = PresetSubtype.LeftRight;
                    }
                }
                // anim rotation
                if (childTNChoice.animRot) {
                    const value = childTNChoice.animRot as ICTTLAnimateRotationBehavior;
                    if (value.by !== undefined) {
                        uiData.props.by = value.by / 60000;
                    }
                    if (uiData.props.by >= 0) {
                        uiData.props.subType = PresetSubtype.Clockwise;
                    } else {
                        uiData.props.subType = PresetSubtype.Counterclockwise;
                    }
                }
            });

            if (sdkData.presetId === PresetId.BrushColor && sdkData.presetClass === STTLTimeNodePresetClassType.emph) {
                // 强调动画-画笔颜色特殊处理，其子动画中只有setBehavior
                maxDur = Number(sdkData?.childTnLst?.egTimeNodeChoice?.[0]?.set?.cBhvr?.cTn?.dur ?? 1);
            }
            uiData.props.duration = maxDur;
        }

        // emph
        if (sdkData.presetId === PresetId.EmphTransparency) {
            if (sdkData.childTnLst?.egTimeNodeChoice && sdkData.childTnLst?.egTimeNodeChoice[0]) {
                if (sdkData.childTnLst?.egTimeNodeChoice[0].set?.to?.strVal !== undefined) {
                    const opacityValue = Number(sdkData.childTnLst?.egTimeNodeChoice[0].set?.to?.strVal.val) || 0;
                    uiData.props.opacityValue = Math.round((1 - opacityValue) * 100);
                }
            }
        }

        // setUiDataAnimTypeWithPresetId
        if (sdkData.presetClass !== undefined && sdkData.presetId !== undefined) {
            const classMap = {
                [presetClassTypes.ENTR]: ENTR_ID_MAP,
                [presetClassTypes.EMPH]: EMPH_ID_MAP,
                [presetClassTypes.EXIT]: EXIT_ID_MAP,
                [presetClassTypes.PATH]: PATH_ID_MAP,
                [presetClassTypes.MEDIA]: MEDIA_ID_MAP,
            };
            let uiDataAnimType = classMap?.[STTLTimeNodePresetClassType[sdkData.presetClass]]?.[sdkData.presetId];

            if (!uiDataAnimType && STTLTimeNodePresetClassType[sdkData.presetClass] === presetClassTypes.PATH) {
                uiDataAnimType = PATH_ANIM_TYPES.CUSTOM;
            }

            if (uiDataAnimType) {
                uiData.props.animType = uiDataAnimType;
            }
        }

        if (sdkData.childTnLst?.egTimeNodeChoice
            && sdkData.childTnLst?.egTimeNodeChoice[0]?.set?.cBhvr?.tgtEl?.spTgt?.spid) {
            uiData.spid = String(sdkData.childTnLst?.egTimeNodeChoice[0]?.set?.cBhvr?.tgtEl?.spTgt?.spid);
        }

        if (uiData.props.animType === AnimType.Appear || uiData.props.animType === AnimType.Disappear) {
            uiData.props.duration = 1;
        }
    }
}
